import { render, staticRenderFns } from "./FullpageProgressBar.vue?vue&type=template&id=6ede722a&scoped=true&"
import script from "./FullpageProgressBar.vue?vue&type=script&lang=js&"
export * from "./FullpageProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede722a",
  null
  
)

export default component.exports